// TODO-KPI-116 (K-B7): 0069 sonrası kategoriye dönen ama değeri olan satır — amber not +
// "Kırılıma dönüştür" kısayolu (kategoriyi toplam göstergesine dönüştür). Yeni kanıt bağı bu
// satırlara 400 aldığı için eski değer + kanıt görünmez kalmasın.

import { KPI_BREAKDOWN_COPY } from "../../lib/kpi-breakdown-copy";

export function LegacyValuesNote(props: {
  canEdit: boolean;
  onConvert: (() => void) | undefined;
}): JSX.Element {
  const C = KPI_BREAKDOWN_COPY.tree;
  return (
    <span
      className="text-xs"
      data-testid="kpi-set-legacy-values"
      style={{
        border: "1px solid var(--color-warning-border)",
        background: "var(--color-warning-bg)",
        color: "var(--color-warning-text)",
        borderRadius: 999,
        padding: "2px 8px",
      }}
    >
      {C.legacyValues}
      {props.canEdit && props.onConvert ? (
        <>
          {" "}
          <button
            type="button"
            data-testid="kpi-set-legacy-convert"
            style={{ textDecoration: "underline", minHeight: 24 }}
            onClick={(e) => {
              e.stopPropagation();
              props.onConvert?.();
            }}
            onKeyDown={(e) => e.stopPropagation()}
          >
            {C.legacyValuesAction}
          </button>
        </>
      ) : null}
    </span>
  );
}
